// App.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import PastYear2324 from './pages/PastYear2324';
import PastYear2021 from './pages/PastYear2021';
import PastYear1819 from './pages/PastYear1819';
import Process from './pages/Process';
import OurTeam from './pages/OurTeam';
import './responsive.css';
import WelcomeMeetPage from 'components/WelcomeMeetPage';
// import NewsSection from 'components/NewsSection';


const App: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />

                <Route path="/WelcomeMeetPage" element={<WelcomeMeetPage />} />
                
                <Route path="pastyear2324" element={<PastYear2324 />} />
                <Route path="pastyear2021" element={<PastYear2021 />} />
                <Route path="pastyear1819" element={<PastYear1819 />} />
                <Route path="ourTeam" element={<OurTeam />} /> 
                <Route path="process" element={<Process />} />
                {/* News Section Route, implement a new news page rather than just  */}
            </Route>
        </Routes>
    );
};

export default App;
